/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import BotInserterConfiguration from 'embercom/objects/series/node/bot-inserter-configuration';

export default class BotNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new BotInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
